'use client';
import {
  CatTooltip,
  CatIconInfo,
  CatTextPassage
} from 'components/blocks-components';
import { useTranslations } from 'next-intl';

const TooltipDisclaimer = ({ availabilityToolTipMessage }) => {
  const t = useTranslations();
  return (
    <div className="pt-1 px-1">
      <CatTooltip position="bottom">
        <CatIconInfo slot="trigger" />
        <CatTextPassage size="sm">
          {availabilityToolTipMessage || t('ECT_AVAILIABILITY_TOOLTIP')}
        </CatTextPassage>
      </CatTooltip>
    </div>
  );
};

export default TooltipDisclaimer;
